<template>
    <div :class="[
        'history-block'
    ]">
        <div class="gabarit">
            <div :class="['heading', state]">
                <h2>{{layout.title}}</h2>
                <transition mode="out-in">
                    <div class="year century" :key="century">{{century}}</div>
                </transition>
            </div>
            <div class="content">
                <div
                    v-for="(story, i) in stories"
                    class="story"
                    ref="stories"
                >
                    <span class="year decades start"><span class="idle">{{starts[i].toString().substr(0,2)}}</span>{{starts[i].toString().substr(-2)}}</span>
                    <span class="year decades" v-if="story.end">–<span class="idle">{{story.end.toString().substr(6, 2)}}</span>{{story.end.toString().substr(8, 2)}}</span>
                    <div class="details">
                        <p class="description">{{story.description}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    data() {
        return {
            animated: true,
            currentCentury: 0,
            state: null
        }
    },
    computed: {
        stories() {
            return this.layout.stories.sort((a, b) => {
                const aDate = new Date(a.date.substring(6, 10), parseInt(a.date.substring(4, 6)) -1, a.date.substring(0, 2))
                const bDate = new Date(b.date.substring(6, 10), parseInt(b.date.substring(4, 6)) -1, b.date.substring(0, 2))
                if(aDate < bDate) return -1;
                if(aDate > bDate) return 1;
                return 0;
            })
        },
        starts() {
            return this.stories.map(_ => {
                return new Date(_.date.substring(6, 10), parseInt(_.date.substring(4, 6)) -1, _.date.substring(0, 2)).getFullYear()
            })
        },
        century() {
            return this.starts[this.currentCentury].toString().substr(0, 2)
        }
    },
    mounted() {
        this.handleResize()
        window.addEventListener('resize', this.handleResize)
        window.requestAnimationFrame(this.render)
    },
    beforeDestroy() {
        this.animated = false
    },
    methods: {
        render() {
            if(this.animated) {
                window.requestAnimationFrame(this.render)
                const bbox = this.$el.getBoundingClientRect()
                const y = -bbox.top
                if(y > 0) {
                    if(y > this.maxHeight) {
                        this.state = 'end'
                    } else {
                        let century = 0
                        this.sizes.some(_ => {
                            const truth = y < _.y
                            if(truth) {
                                century = _.index
                            } else {
                                century = 0
                            }
                            return truth
                        })
                        this.currentCentury = century
                        this.state = 'fixed'
                    }
                } else {
                    this.state = null
                }
            }
        },
        handleResize() {
            this.height = this.$el.offsetHeight
            this.windowHeight = window.innerHeight
            this.maxHeight = this.height - this.windowHeight
            this.sizes = this.$refs.stories.map((_, index) => {
                return { y: _.offsetTop + _.offsetHeight - this.windowHeight * 0.625, index }
            })
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.history-block
    margin-top: 10%
    margin-bottom: 10%
    @include media-breakpoint-up($xxl)
        margin-left: calc((-100vw + 1920px) * 0.5)
        margin-right: calc((-100vw + 1920px) * 0.5)
    @media print
        margin-top: 1.2cm
        margin-bottom: 1.2cm
.gabarit
    position: relative
.heading
    background-color: #114991
    flex: 0.5
    padding-left: 10vw
    padding-top: 7.8125vw
    height: 100vh
    position: absolute
    width: 50vw
    left: 0
    top: 0
    @include media-breakpoint-down($lg)
        padding-bottom: 7.8125vw
        position: static
        width: auto
        height: auto
    @media print
        width: auto
        height: auto
        padding-top: 0
        padding-left: 0
        padding-bottom: 0
    &.fixed
        position: fixed
        @include media-breakpoint-down($lg)
            position: static
    &.end
        top: 100%
        transform: translateY(-100%)
    h2
        color: #ffffff
        font-size: 50px
        font-weight: 500
        max-width: 8em
        line-height: 1.1625
        letter-spacing: -0.0315em
        @media print
            font-size: 28px
            max-width: initial
    .century
        color: #ffffff
        position: absolute
        bottom: 0
        right: 0
        margin-bottom: 23.1481481481%
        margin-right: .125em
        @include media-breakpoint-down($lg)
            display: none
        &.v-enter-active
            transition: opacity .2s, transform .3s
        &.v-leave-active
            transition: opacity .2s, transform .3s
        &.v-enter
            opacity: 0
            transform: translateY(25%)
        &.v-leave-to
            opacity: 0
            transform: translateY(-25%)

.content
    background-color: #f4f8f8
    width: 50vw
    margin-left: auto
    min-height: 100vh
    @include media-breakpoint-down($lg)
        width: auto
.decades
    padding-left: .0625em
    @include media-breakpoint-down($lg)
        padding-left: 0%
        &.start
            margin-left: -0.3125em
.details
    min-height: 40.7407407407vh
    padding-top: 5.8333333333% * 2
    padding-left: 15.625% * 2
    // padding-right: 12.5% * 2
    padding-right: 9.6%
    padding-bottom: 5.8333333333% * 2
    position: relative
    @include media-breakpoint-down($lg)
        padding-left: 9.6%
        min-height: initial
    @media print
        padding-left: 9.6%
        padding-right: 9.6%
        padding-top: 0
        padding-bottom: 0
        margin-top: .3cm
        margin-bottom: .3cm
    &:before
        display: block
        content: ""
        width: 1px
        height: 100%
        position: absolute
        left: 15.625%
        top: 0
        background-color: #d7dbdd
        @include media-breakpoint-down($lg)
            left: 0%
    &:after
        display: block
        content: ""
        background-color: #ff2b2a
        width: 40px
        height: 40px
        border-radius: 20px
        position: absolute
        left: 15.625%
        margin-left: -20px
        top: 100%
        margin-top: 20px
        @include media-breakpoint-down($lg)
            left: 0%
            width: 20px
            height: 20px
            border-radius: 10px
            margin-left: -10px
            margin-top: 10px
        @media print
            display: none
.idle
    display: none
    @include media-breakpoint-down($lg)
        display: inline
.year
    font-size: 330px
    font-size: 15.5vw
    font-weight: 500
    letter-spacing: -0.075em
    @media print
        font-size: 28px

.story
    min-height: calc(100vh - 240px)
    padding-right: .125em
    padding-bottom: 60px
    padding-top: 20px
    @include media-breakpoint-down($lg)
        min-height: initial
        padding-top: 10px
        padding-left: 9.6%
    @media print
        padding-top: 0
        padding-bottom: 0
        margin-top: .6cm
        margin-bottom: .6cm
    &:last-child
        .details
            &:after
                display: none
.description
    font-size: 28px
    line-height: 1.4285714286
    max-width: 420px
    @include media-breakpoint-down($sm)
        font-size: 17px
    @media print
        max-width: initial
</style>
